/* Archive filters: tag chips + year picker.
   Year pills are derived from the rendered rows' data-arch-year attributes;
   tag pills are server-rendered (we know the publication's tag set at build-render time).
*/
(function () {
  var rows = document.querySelectorAll('[data-arch-row]');
  if (!rows.length) return;

  var yearContainer = document.querySelector('[data-arch-year-pills]');
  var countEl = document.querySelector('[data-arch-count]');
  var tagButtons = document.querySelectorAll('[data-arch-tag-filter]');
  var yearButtons; // populated after we inject year pills

  // Derive years from rows.
  var years = {};
  rows.forEach(function (row) {
    var y = row.getAttribute('data-arch-year');
    if (y) years[y] = true;
  });
  var yearList = Object.keys(years).sort().reverse();

  // Inject year pills.
  if (yearContainer && yearList.length) {
    yearList.forEach(function (year) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'op-pill';
      btn.setAttribute('data-arch-year-filter', year);
      btn.textContent = year;
      yearContainer.appendChild(btn);
    });
  }
  yearButtons = document.querySelectorAll('[data-arch-year-filter]');

  var activeTag = '';
  var activeYear = '';

  function apply() {
    var visible = 0;
    rows.forEach(function (row) {
      var rowYear = row.getAttribute('data-arch-year') || '';
      var rowTags = (row.getAttribute('data-arch-tags') || '').trim().split(/\s+/);
      var matchYear = !activeYear || rowYear === activeYear;
      var matchTag  = !activeTag  || rowTags.indexOf(activeTag) !== -1;
      if (matchYear && matchTag) {
        row.removeAttribute('data-arch-hidden');
        visible++;
      } else {
        row.setAttribute('data-arch-hidden', '');
      }
    });
    if (countEl) {
      countEl.textContent = visible + ' issue' + (visible === 1 ? '' : 's');
    }
  }

  function setActive(group, value) {
    group.forEach(function (btn) {
      btn.classList.toggle('is-active',
        (btn.getAttribute('data-arch-tag-filter') === value) ||
        (btn.getAttribute('data-arch-year-filter') === value));
    });
  }

  tagButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      activeTag = btn.getAttribute('data-arch-tag-filter') || '';
      setActive(tagButtons, activeTag);
      apply();
    });
  });

  yearButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      activeYear = btn.getAttribute('data-arch-year-filter') || '';
      setActive(yearButtons, activeYear);
      apply();
    });
  });

  apply();
})();
